import type { JobPost } from "../../types/jben/job_post";

export const showEmployment = (jobPost: JobPost) => {
  if (!jobPost?.employment) return false;
  return jobPost.employment !== "hidden";
};

export const employmentRequired = (jobPost: JobPost) => jobPost.employment === "required";
